export default "__VITE_ASSET__Cofl5OTR__"